import { Link, Text } from 'components/typography';
import { Box } from 'components/box';
import { css } from '@emotion/react';
import config from '../../../util/load-config';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const listStyle = css`
  display: list-item;
  list-style-type: disc;
`;

const Returnable = () => (
  <>
    <Text mb="2" lineHeight="1.7">
      Yes, we do accept returns within 7 days of receipt, provided the item is
      in its original condition and packaging.
    </Text>
    <Text my="2" lineHeight="1.7">
      Certain products are excluded and may not be returned, including:
    </Text>

    <Box pl="4">
      <Text css={listStyle} lineHeight="1.7">
        Products received more than 7 days prior
      </Text>
      <Text css={listStyle} lineHeight="1.7">
        Products that have been used or are missing any parts or accessories
      </Text>
      <Text css={listStyle} lineHeight="1.7">
        Products that have been opened or unsealed, including (but not limited
        to): Swimwear, underwear, lingerie, bodysuits, beauty and cosmetic items
        and devices, fragrances, linen, bedding, towels, DVD&apos;s, CD&apos;s,
        games, software, foodstuffs, supplements, adult toys and accessories,
        animal feed, cleaning products, medical equipment, personal protective
        equipment, certain jewellery items, earphones and electronics
      </Text>
      <Text css={listStyle} lineHeight="1.7">
        Vouchers such as a service-related voucher, travel deals or other
        digital downloads
      </Text>
      <Text css={listStyle} lineHeight="1.7">
        Personalised products or products that have been made to the
        customer&apos;s specifications
      </Text>
      <Text css={listStyle} lineHeight="1.7">
        A product where the customer has already registered the warranty
      </Text>
    </Box>

    <Text my="2"> All returns are subject to quality checks.</Text>
    <Text mt="2" lineHeight={1.7}>
      Please refer to our{' '}
      <Link target="_blank" href={config.helpCentreLinks.aboutReturns}>
        returns page
      </Link>{' '}
      for further information.
    </Text>
  </>
);

const NonReturnable = () => (
  <>
    <Text mb="2" lineHeight="1.7">
      This product is non-returnable, but if the product is faulty, you may
      request a refund.
    </Text>
    <Text mt="2" lineHeight="1.7">
      Please refer to our{' '}
      <Link target="_blank" href={config.helpCentreLinks.aboutReturns}>
        returns page
      </Link>{' '}
      for further information.
    </Text>
  </>
);

const Returns = ({
  isReturnable,
  close,
  isOpen,
}: {
  isReturnable: boolean;
  close: () => void;
  isOpen: boolean;
}) => (
  <Modal
    close={close}
    isOpen={isOpen}
    size="small"
    title={
      isReturnable
        ? 'Can I return this product?'
        : "This product can't be returned"
    }
  >
    {isReturnable ? <Returnable /> : <NonReturnable />}
  </Modal>
);

export default Returns;
